module.exports = __webpack_public_path__ + "img/v-sport-IDG-s-min.b423d90e.png";